/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import {
  Boton,
  Titulo,
  Formulario,
  accessAPI,
  Sidebar,
  useFuncionalidad, tituloBase, TablaFiltrable } from "../../../../shared";

const SEARCH_FIELDS = ["etiqueta"];

export default function Esquemas() {
  const [loader, setLoader] = useState(true);
  const [esquemas, setEsquemas] = useState([]);
  const [sideBar, setSideBar] = useState(false);
  const [formLoader, setFormLoader] = useState(false);
  const conUrsea = useFuncionalidad("URSEA");

  const toast = useRef(null);
  const navigate = useNavigate();

  function crearEsquema(camposFormulario) {
    setFormLoader(true);
    accessAPI(
      "POST",
      "admin/config/esquema",
      camposFormulario,
      (respuesta) => {
        navigate(`/esquemas/${respuesta.id}`);
      },
      (respuesta) => {
        setFormLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al crear esquema",
          sticky: true
        });
      }
    );
  }

  const crearFormConfig = {
    secciones: [
      {
        nombre: "Datos del nuevo esquema",
        campos: [
          {
            nombre: "etiqueta",
            tipoitemformularioid: 1,
            etiqueta: "Etiqueta",
            requerido: true
          },
          // El nombre en URSEA solo se pide si el organismo tiene la
          // integración prendida.
          ...(conUrsea
            ? [
                {
                  nombre: "nombre",
                  tipoitemformularioid: 1,
                  etiqueta: "Nombre certificado digital URSEA",
                }
              ]
            : []),
          {
            nombre: "descripcion",
            tipoitemformularioid: 1,
            etiqueta: "Descripción",
            requerido: true
          },
          {
            nombre: "detalles",
            tipoitemformularioid: 11,
            etiqueta: "Detalles"
          }
        ]
      }
    ],
    botones: [
      { etiqueta: "Crear esquema", callback: crearEsquema, validar: true }
    ]
  };

  useEffect(() => {
    document.title = "Esquemas";
    accessAPI(
      "GET",
      "admin/config/esquema/config",
      null,
      (respuesta) => {
        setEsquemas(respuesta);
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar esquemas",
          sticky: true
        });
        setLoader(false);
      }
    );
    return () => (document.title = tituloBase());
  }, []);

  return (
    <>
      <Toast ref={toast} position="top-center" />

      <Sidebar
        visible={sideBar}
        onHide={() => setSideBar(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Nuevo esquema</Titulo>
        <Formulario config={crearFormConfig} loader={formLoader} />
      </Sidebar>

      {loader && (
        <div css={{ marginTop: "2em", display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          <div css={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
            <Skeleton width="15rem" height="2.5rem" />
            <Skeleton width="12rem" height="2.5rem" />
          </div>
          <Card>
            <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              <Skeleton width="100%" height="3rem" />
              {[...Array(5)].map((_, i) => (
                <Skeleton key={i} width="100%" height="3.5rem" />
              ))}
            </div>
          </Card>
        </div>
      )}

      {!loader && (
        <div>
          <Titulo
            urlVolver="/config"
            botones={
              <Boton callback={() => setSideBar(true)}>Nuevo esquema</Boton>
            }
          >
            Esquemas
          </Titulo>

          <Card>
            <TablaFiltrable
              value={esquemas}
              searchFields={SEARCH_FIELDS}
              anchoBusqueda="33%"
              nombreArchivo="esquemas"
              emptyMessage="No hay esquemas registrados"
              onRowClick={(e) => {
                if (e.originalEvent.metaKey || e.originalEvent.ctrlKey) {
                  window.open(`/esquemas/${e.data.id}`, "_blank");
                } else {
                  navigate(`/esquemas/${e.data.id}`);
                }
              }}
              rows={10}
              css={{
                "& .p-datatable-tbody > tr": { cursor: "pointer" }
              }}
            >
              <Column header="Nombre" field="etiqueta" />
            </TablaFiltrable>
          </Card>
        </div>
      )}
    </>
  );
}
